module.exports = __webpack_public_path__ + "281fdc1ec5a18cf0b5ddd98846a7f34e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/necklace-coin-s.png
// module id = 1319
// module chunks = 0